import request from '@/utils/request'

// 查询检验资质列表
export function listJyzz(query) {
  return request({
    url: '/web/zlts/ylqxcx/jyzz/getJyzzList',
    method: 'get',
    params: query
  })
}

// 查询检测能力列表
export function listJcnl(query) {
  return request({
    url: '/web/zlts/ylqxcx/jyzz/getJcnlList',
    method: 'get',
    params: query
  })
}

// 查询医疗器械创新-检验资质-设备列表
export function listSb(query) {
  return request({
    url: '/web/zlts/ylqxcx/jyzz/getSbList',
    method: 'get',
    params: query
  })
}

// 查询检验资质证书列表
export function listZs(query) {
  return request({
    url: '/web/zlts/ylqxcx/jyzz/getZsList',
    method: 'get',
    params: query
  })
}